import { useSelector } from "react-redux";
import ArrayEntry from "../../datatypeComponents/ArrayEntry";
import addElementValuesForBaselineMeasureReportFromComparativeEvidenceReport from "../compositionResourceFunctions/addElementValuesForBaselineMeasureReportFromComparativeEvidenceReport";
import addElementValuesForOutcomeMeasureReportFromComparativeEvidenceReport from "../compositionResourceFunctions/addElementValuesForOutcomeMeasureReportFromComparativeEvidenceReport";
import addElementValuesForOutcomeMeasureReportFromComparativeEvidenceSynthesisReport from "../compositionResourceFunctions/addElementValuesForOutcomeMeasureReportFromComparativeEvidenceSynthesisReport";
import addElementValuesForParticipantFlowReportFromComparativeEvidenceReport from "../compositionResourceFunctions/addElementValuesForParticipantFlowReportFromComparativeEvidenceReport";
import addElementValuesForSummaryOfFindingsFromComparativeEvidenceReport from "../compositionResourceFunctions/addElementValuesForSummaryOfFindingsFromComparativeEvidenceReport";
import addElementValuesForSummaryOfFindingsFromComparativeEvidenceSynthesisReport from "../compositionResourceFunctions/addElementValuesForSummaryOfFindingsFromComparativeEvidenceSynthesisReport";
import generateComparatorGroupValues from "../compositionResourceFunctions/generateComparatorGroupValues";
import generateGroupAssignmentValues from "../compositionResourceFunctions/generateGroupAssignmentValues";
import generateInterventionGroupValues from "../compositionResourceFunctions/generateInterventionGroupValues";
import { selectComparativeEvidenceMap } from "../../slices/comparativeEvidenceMap/comparativeEvidenceMapSlice";
import { Button } from "semantic-ui-react";
import addElementValuesForSummaryOfNetEffectFromComparativeEvidenceSynthesisReport from "../compositionResourceFunctions/addElementValuesForSummaryOfNetEffectFromComparativeEvidenceSynthesisReport";

const extractOutcomeMeasuresFromResearchStudy = (researchStudyJson, setSectionState) => {
    if (!researchStudyJson) {
        alert("No ResearchStudy JSON detected.");
        return;
    }
    if (!researchStudyJson.objective) {
        alert("No ResearchStudy.objective detected.");
        return;
    }
    if (!Array.isArray(researchStudyJson.objective)) {
        alert("No ResearchStudy.objective array detected.");
        return;
    }
    if (researchStudyJson.objective.length === 0) {
        alert("No ResearchStudy.objective instances detected.");
        return;
    }
    let outcomeMeasureReferences = [];
    for (const objective of researchStudyJson.objective) {
        if (objective.outcomeMeasure?.length > 0) {
            for (const outcomeMeasure of objective.outcomeMeasure) {
                if (outcomeMeasure.endpoint) {
                    outcomeMeasureReferences.push(outcomeMeasure.endpoint);
                }
            }
        }
    }
    if (outcomeMeasureReferences.length === 0) {
        alert("No ResearchStudy.objective.outcomeMeasure.endpoint instances detected.");
        return;
    }
    setSectionState(prevState => { return { ...prevState, "entry": outcomeMeasureReferences } });
}

const SectionEntryArrayEntry = ({ sectionState, setSectionState, sectionLoaded, foi,
    revisedResourceJson, associatedOutcomeMeasureReportState, slicePattern }) => {

    const resourceReferenceMap = useSelector(selectComparativeEvidenceMap);
    let researchStudyJson;
    let startingResourceType;
    let referencedResourceTypes;
    let selectAnyProfile = true;
    let setProfile;
    let selectProfile;
    let addElementValues = {
        "partOfRelationshipReference": {
            "reference": "Composition/" + foi,
            "type": "Composition",
            "display": sectionLoaded.compositionTitle
        }
    }

    if (sectionLoaded) {
        if (sectionLoaded.sectionCode === "references") {
            startingResourceType = "Citation";
            referencedResourceTypes = ["Citation"];
        } else if (sectionLoaded.compositionType === "OutcomeMeasureReport" ||
            sectionLoaded.compositionType === "BaselineMeasureReport") {
            if (sectionLoaded.sectionCode === "results") {
                selectAnyProfile = false;
                selectProfile = ["NonComparativeEvidence", "ComparativeEvidence", "BaselineMeasureEvidence",
                    "InterventionOnlyEvidence", "ComparatorOnlyEvidence", "ComparativeBaselineMeasureEvidence"];
                startingResourceType = "Evidence";
                referencedResourceTypes = ["Evidence"];
            }
        } else if (sectionLoaded.compositionType === "ParticipantFlowReport") {
            if (sectionLoaded.sectionCode === "results") {
                selectAnyProfile = false;
                selectProfile = ["ParticipantFlowEvidence", "ComparativeParticipantFlowEvidence",
                    "NonComparativeEvidence", "ComparativeEvidence", "InterventionOnlyEvidence", "ComparatorOnlyEvidence"];
                startingResourceType = "Evidence";
                referencedResourceTypes = ["Evidence"];
            }
        } else if (sectionLoaded.compositionType === "ComparativeEvidenceSynthesisReport") {
            if (sectionLoaded.sectionCode === "population") {
                selectAnyProfile = false;
                selectProfile = ["CohortDefinition", "ConceptualCohortDefinition", "StudyEligibilityCriteria"];
                referencedResourceTypes = ["Group"];
                startingResourceType = "Group";
            } else if (sectionLoaded.sectionCode === "intervention-description") {
                selectAnyProfile = false;
                referencedResourceTypes = ["Group", "PlanDefinition", "ActivityDefinition"];
                selectProfile = ["ConceptualExposureDefinition"];
            } else if (sectionLoaded.sectionCode === "comparator-description") {
                selectAnyProfile = false;
                referencedResourceTypes = ["Group", "PlanDefinition", "ActivityDefinition"];
                selectProfile = ["AbsenceOfExposureDefinition", "ConceptualComparatorDefinition", "ConceptualExposureDefinition"];
            } else if (sectionLoaded.sectionCode === "research-study") {
                referencedResourceTypes = ["ResearchStudy", "Citation", "Composition"];
            } else if (sectionLoaded.sectionCode === "variables") {
                selectAnyProfile = false;
                selectProfile = ["VariableDefinition", "OutcomeVariablesList"];
                referencedResourceTypes = ["EvidenceVariable", "List"];
                if (resourceReferenceMap?.researchStudyJson) {
                    researchStudyJson = resourceReferenceMap.researchStudyJson;
                }
            } else if (sectionLoaded.sectionCode === "results") {
                selectAnyProfile = false;
                setProfile = "OutcomeMeasureReport";
                referencedResourceTypes = ["Composition"];
                startingResourceType = "Composition";
                addElementValues = addElementValuesForOutcomeMeasureReportFromComparativeEvidenceSynthesisReport(revisedResourceJson);
            } else if (sectionLoaded.sectionCode === "summary-of-findings") {
                selectAnyProfile = false;
                setProfile = "SummaryOfFindings";
                referencedResourceTypes = ["Composition"];
                startingResourceType = "Composition";
                addElementValues = addElementValuesForSummaryOfFindingsFromComparativeEvidenceSynthesisReport(revisedResourceJson,
                    resourceReferenceMap, associatedOutcomeMeasureReportState);
            } else if (sectionLoaded.sectionCode === "net-effect") {                
                selectAnyProfile = false;
                setProfile = "SummaryOfNetEffect";
                referencedResourceTypes = ["Composition"];
                startingResourceType = "Composition";
                addElementValues = addElementValuesForSummaryOfNetEffectFromComparativeEvidenceSynthesisReport(revisedResourceJson,
                    resourceReferenceMap, associatedOutcomeMeasureReportState);
            }
        } else if (sectionLoaded.compositionType === "ComparativeEvidenceReport" ||
            sectionLoaded.compositionType === "ComparativeEvidenceReportExpanded"
        ) {
            if (sectionLoaded.sectionCode === "study-sample" || sectionLoaded.sectionCode === "screened-group" ||
                sectionLoaded.sectionCode === "excluded-group"
            ) {
                selectAnyProfile = false;
                setProfile = "StudyGroup";
                startingResourceType = "Group";
                referencedResourceTypes = ["Group"];
            } else if (sectionLoaded.sectionCode === "intervention-group") {
                selectAnyProfile = false;
                setProfile = "ExposureGroup";
                startingResourceType = "Group";
                referencedResourceTypes = ["Group"];
                addElementValues = generateInterventionGroupValues(resourceReferenceMap) || {
                    "partOfRelationshipReference": {
                        "reference": "Composition/" + foi,
                        "type": "Composition",
                        "display": sectionLoaded.compositionTitle
                    }
                };
            } else if (sectionLoaded.sectionCode === "comparator-group") {
                selectAnyProfile = false;
                setProfile = "ComparatorGroup";
                startingResourceType = "Group";
                referencedResourceTypes = ["Group"];
                addElementValues = generateComparatorGroupValues(resourceReferenceMap) || {
                    "partOfRelationshipReference": {
                        "reference": "Composition/" + foi,
                        "type": "Composition",
                        "display": sectionLoaded.compositionTitle
                    }
                };
            } else if (sectionLoaded.sectionCode === "eligibility-criteria") {
                selectAnyProfile = false;
                setProfile = "StudyEligibilityCriteria";
                startingResourceType = "Group";
                referencedResourceTypes = ["Group"];
            } else if (sectionLoaded.sectionCode === "intervention-description" ||
                sectionLoaded.sectionCode === "comparator-description"
            ) {
                referencedResourceTypes = ["Group", "PlanDefinition", "ActivityDefinition"];
            } else if (sectionLoaded.sectionCode === "GroupAssignment" ||
                sectionLoaded.sectionCode === "group-assignment"
            ) {
                selectAnyProfile = false;
                setProfile = "GroupAssignment";
                startingResourceType = "EvidenceVariable";
                referencedResourceTypes = ["EvidenceVariable"];
                addElementValues = generateGroupAssignmentValues(resourceReferenceMap) || {
                    "partOfRelationshipReference": {
                        "reference": "Composition/" + foi,
                        "type": "Composition",
                        "display": sectionLoaded.compositionTitle
                    }
                };
            } else if (sectionLoaded.sectionCode === "research-study") {
                startingResourceType = "ResearchStudy";
                referencedResourceTypes = ["ResearchStudy", "Citation", "Composition"];
            } else if (sectionLoaded.sectionCode === "outcome-measures") {
                selectAnyProfile = false;
                selectProfile = ["VariableDefinition", "OutcomeVariablesList"];
                referencedResourceTypes = ["EvidenceVariable", "List"];
                if (resourceReferenceMap?.researchStudyJson) {
                    researchStudyJson = resourceReferenceMap.researchStudyJson;
                }
            } else if (sectionLoaded.sectionCode === "baseline-measures") {
                selectAnyProfile = false;
                selectProfile = ["VariableDefinition", "BaselineVariablesList"];
                referencedResourceTypes = ["EvidenceVariable", "List"];
            } else if (sectionLoaded.sectionCode === "participant-flow-measures") {
                selectAnyProfile = false;
                selectProfile = ["ParticipantFlowEvidenceVariable", "ParticipantFlowReasonEvidenceVariable", "ParticipantFlowVariablesList"];
                referencedResourceTypes = ["EvidenceVariable", "List"];
            } else if (sectionLoaded.sectionCode === "baseline-characteristics") {
                selectAnyProfile = false;
                setProfile = "BaselineMeasureReport";
                referencedResourceTypes = ["Composition"];
                startingResourceType = "Composition"
                addElementValues = addElementValuesForBaselineMeasureReportFromComparativeEvidenceReport(revisedResourceJson);
            } else if (sectionLoaded.sectionCode === "participant-flow") {
                selectAnyProfile = false;
                setProfile = "ParticipantFlowReport";
                referencedResourceTypes = ["Composition"];
                startingResourceType = "Composition"
                addElementValues = addElementValuesForParticipantFlowReportFromComparativeEvidenceReport(revisedResourceJson);
            } else if (sectionLoaded.sectionCode === "outcome-findings") {
                selectAnyProfile = false;
                setProfile = "OutcomeMeasureReport";
                referencedResourceTypes = ["Composition"];
                startingResourceType = "Composition"
                addElementValues = addElementValuesForOutcomeMeasureReportFromComparativeEvidenceReport(revisedResourceJson);
            } else if (sectionLoaded.sectionCode === "summary-of-findings") {
                selectAnyProfile = false;
                setProfile = "SummaryOfFindings";
                referencedResourceTypes = ["Composition"];
                startingResourceType = "Composition"
                addElementValues = addElementValuesForSummaryOfFindingsFromComparativeEvidenceReport(revisedResourceJson,
                    resourceReferenceMap, associatedOutcomeMeasureReportState);
            }
        } else if (sectionLoaded.compositionType === "Guideline" &&
            sectionLoaded.sectionCode === "recommendations") {
            selectAnyProfile = false;
            setProfile = "Recommendation";
            startingResourceType = "Composition";
        } else if (sectionLoaded.compositionType === "Recommendation") {
            if (sectionLoaded.sectionCode === "ratings") {
                selectAnyProfile = false;
                selectProfile = ["RecommendationRating", "RecommendationJustification"];
                startingResourceType = "ArtifactAssessment";
                addElementValues = {
                    "artifactReference": {
                        "reference": "Composition/" + foi,
                        "type": "Composition",
                        "display": sectionLoaded.compositionTitle
                    },
                    "partOfRelationshipReference": {
                        "reference": "Composition/" + foi,
                        "type": "Composition",
                        "display": sectionLoaded.compositionTitle
                    }
                };
            } else if (sectionLoaded.sectionCode === "justification") {
                selectAnyProfile = false;
                setProfile = "RecommendationJustification";
                startingResourceType = "ArtifactAssessment";
                addElementValues = {
                    "artifactReference": {
                        "reference": "Composition/" + foi,
                        "type": "Composition",
                        "display": sectionLoaded.compositionTitle
                    },
                    "partOfRelationshipReference": {
                        "reference": "Composition/" + foi,
                        "type": "Composition",
                        "display": sectionLoaded.compositionTitle
                    }
                };
            } else if (sectionLoaded.sectionCode === "population") {
                selectAnyProfile = false;
                setProfile = "RecommendationEligibilityCriteria";
                startingResourceType = "Group";
            } else if (sectionLoaded.sectionCode === "action") {
                startingResourceType = "PlanDefinition";
            }
        } else if (sectionLoaded.compositionType === "ResearchStudyDataDictionary" &&
            sectionLoaded.sectionCode === "variables") {
            selectAnyProfile = false;
            setProfile = "VariableDefinition";
            startingResourceType = "EvidenceVariable";
        }
    }

    return <>
        {(resourceReferenceMap && researchStudyJson) &&
            <>
                <Button style={{ color: "#FFFFFF", width: "230px", float: "left" }} className="formButton"
                    content="Extract Outcome Measures from Research Study" positive
                    onClick={() => {
                        extractOutcomeMeasuresFromResearchStudy(researchStudyJson, setSectionState);
                    }}
                />
            </>}
        <ArrayEntry datatype="Reference" elementName="entry"
            fieldLabel="Resource Reference"
            startingValue={sectionState.entry}
            setResourceState={setSectionState}
            addElementValues={addElementValues}
            deletable deletableArray doNotShowFieldLabel={false}
            startEmptyArrayClosed startCollapsed
            startingResourceType={startingResourceType}
            referencedResourceTypes={referencedResourceTypes}
            selectAnyProfile={selectAnyProfile} setProfile={setProfile}
            selectProfile={selectProfile}
            enableCreation />
    </>
};

export default SectionEntryArrayEntry;